// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M22 2H8V7.15003C4.57664 7.84493 2 10.8716 2 14.5C2 18.6421 5.35786 22 9.5 22C13.1284 22 16.1551 19.4234 16.85 16H22V2ZM16.9836 14C16.7372 10.2562 13.7438 7.26282 10 7.0164V4H20V14H16.9836Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-icon-filled')
export default class IconFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'icon-filled',
    }
  }
}
